import { QueryConfig } from "store/utils/query-config";

export const callBackRequestsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["-metaData.createdAt"]
  }
};
